import { render } from "./PessoaFisica.vue?vue&type=template&id=aa4b5564&scoped=true"
import script from "./PessoaFisica.vue?vue&type=script&lang=js"
export * from "./PessoaFisica.vue?vue&type=script&lang=js"

import "./PessoaFisica.vue?vue&type=style&index=0&id=aa4b5564&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4b5564"]])

export default __exports__